/**
 * SnapshotProcessing Component
 * Full-screen modal with loading animation
 */

import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SnapshotProcessingProps {
  className?: string;
}

export function SnapshotProcessing({ className }: SnapshotProcessingProps) {
  return (
    <div className={cn(
      "fixed inset-0 z-50",
      "bg-background/95 backdrop-blur-sm",
      "flex items-center justify-center",
      className
    )}>
      <div className="text-center space-y-4">
        <Loader2 className="w-12 h-12 animate-spin text-primary mx-auto" />
        <h2 className="text-2xl font-semibold text-foreground">
          Analyzing your swings...
        </h2>
        <p className="text-muted-foreground">
          Aggregating analysis results from 5 swings
        </p>
        <div className="flex items-center justify-center gap-2 pt-4">
          <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
          <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
          <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>
      </div>
    </div>
  );
}


